module.exports = __webpack_public_path__ + "283fbf484ddf05c53dc27cb29814af2f.pdf";